function addSpinner(element) {
    const card = element.closest('.card');

    // Create spinner container
    const spinnerContainer = document.createElement('div');
    spinnerContainer.classList.add('ajax-spinner-container');
    spinnerContainer.style.position = 'absolute';
    spinnerContainer.style.top = '0';
    spinnerContainer.style.left = '0';
    spinnerContainer.style.width = '100%';
    spinnerContainer.style.height = '100%';
    spinnerContainer.style.display = 'flex';
    spinnerContainer.style.justifyContent = 'center';
    spinnerContainer.style.alignItems = 'center';
    spinnerContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'; // Semi-transparent white background
    spinnerContainer.style.zIndex = '2';
    spinnerContainer.style.cursor = 'pointer';

    // Create spinner element (you can customize the spinner)
    const spinner = document.createElement('div');
    spinner.classList.add('ajax-spinner');
    spinner.innerHTML = `
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  `;

    spinnerContainer.appendChild(spinner);
    card.appendChild(spinnerContainer);  // Append spinner after the card content
    return spinnerContainer
}

function removeSpinner(spinnerContainer) {
    if (spinnerContainer) {
        spinnerContainer.remove();
    }
}

export { addSpinner, removeSpinner }